import { useState } from "react";
import PrimaryButton from "../../Components/Buttons/PrimaryButton/PrimaryButton";
import Modal, { ModalBody, ModalFooter } from "../../Components/Modal/Modal";
import classes from "./PaymentOptionCard.module.css";
import { useSelector } from "react-redux";

const paypal = "paypal";
const stripe = "stripe";

const paypalSupportedCurrencies = [
  "AUD", // Australian Dollar
  "BRL", // Brazilian Real
  "CAD", // Canadian Dollar
  "CNY", // Chinese Yuan
  "CZK", // Czech Koruna
  "DKK", // Danish Krone
  "EUR", // Euro
  "HKD", // Hong Kong Dollar
  "HUF", // Hungarian Forint
  "ILS", // Israeli New Shekel
  "JPY", // Japanese Yen
  "MYR", // Malaysian Ringgit
  "MXN", // Mexican Peso
  "NOK", // Norwegian Krone
  "NZD", // New Zealand Dollar
  "PHP", // Philippine Peso
  "PLN", // Polish Zloty
  "GBP", // Pound Sterling (British Pound)
  "RUB", // Russian Rubles
  "SGD", // Singapore Dollar
  "SEK", // Swedish Krona
  "CHF", // Swiss Franc
  "TWD", // Taiwan New Dollar
  "THB", // Thai Baht
  "USD"  // U.S. Dollar
];

const PaymentOptionCard = ({onSelect, onClose }) => {
  const [method, setMethod] = useState(paypal);
  const currentUser = useSelector((state) => state.user.currentUser);

  const continueToPayment = async() => {
      onSelect?.(method);
      onClose();
  }

  const isAlloweByPaypal = () => {
    if(paypalSupportedCurrencies.includes(currentUser?.preferredCurrency)) {
      return true;
    }
    return false;
  }

  return (
    <Modal className={classes.modal} title="Choose your payment method" onClose={onClose}>
      <ModalBody>
        <div className={classes.main}>
          {isAlloweByPaypal() && <div className={classes.radio}>
            <input
              type="radio"
              name=""
              id="paypal"
              value={method}
              checked={method === paypal}
              onChange={() => setMethod(paypal)}
            />
            <label htmlFor="paypal">PayPal</label>
          </div>}
          <div className={classes.radio}>
            <input
              type="radio"
              name=""
              id="card-payment"
              value={method}
              checked={method === stripe}
              onChange={() => setMethod(stripe)}
            />
            <label htmlFor="card-payment">Credit/Debit Card/NetBanking</label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={classes.actions}>
          <PrimaryButton onClick={continueToPayment}>Continue</PrimaryButton>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default PaymentOptionCard;
